import React, { Fragment, useState } from "react";
import { connect } from "react-redux";

const CompanyCardItem = ({
  jobposition: { _id, positionname, positionimage, positioninfo },
}) => {
  const [flipCard, setflipCard] = useState(false);
  const flip = (id) => {
    if (_id === id) {
      setflipCard(true);
    } else {
      setflipCard(false);
    }
  };
  return (
    <Fragment>
      <div className="position-card">
        {!flipCard && (
          <div className="card-div" onClick={(e) => flip(_id)}>
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/employer_spotlight_images/${positionimage}`}
              alt="position"
              className="position-card-image"
            />
            <div className="position-card-info">
              <p className="position-card-name green">{positionname}</p>
              <i className="fas fa-retweet fa-2x green mx-5 cursor"></i>
            </div>
          </div>
        )}
        {flipCard && (
          <div className="back-of-card" onClick={(e) => setflipCard(false)}>
            <p className="card-info white" id="green-scroll">
              {positioninfo}
            </p>
            <div className="position-card-info">
              <p className="position-card-name green">{positionname}</p>
              <i className="fas fa-retweet fa-2x green mx-5 cursor"></i>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  episode: state.companyweek,
});

export default connect(mapStateToProps)(CompanyCardItem);
